import { render, staticRenderFns } from "./bulma_form.vue?vue&type=template&id=1b3c7944&scoped=true&lang=html"
import script from "./bulma_form.vue?vue&type=script&lang=js"
export * from "./bulma_form.vue?vue&type=script&lang=js"
import style0 from "./bulma_form.vue?vue&type=style&index=0&id=1b3c7944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3c7944",
  null
  
)

export default component.exports